/**
 * 二维码渲染。
 *
 * 用本地 vendored 的 qrcode-generator（MIT）而不是 npm 包或在线服务：
 * 门店收银机/触屏机可能**没有外网**，而「屏幕上出码」是顾客付款的唯一入口，
 * 这个动作绝不能依赖 CDN 或者网络是否通畅。
 *
 * 输出 SVG 而不是 PNG：触屏机屏幕尺寸不一，SVG 放大不糊，
 * 顾客隔半米扫也能扫得动。
 */

interface QrCodeInstance {
  addData(data: string): void;
  make(): void;
  createSvgTag(options: { cellSize?: number; margin?: number; alt?: string; title?: string }): string;
}

interface QrCodeFactory {
  (typeNumber: number, errorCorrectionLevel: string): QrCodeInstance;
}

declare global {
  interface Window {
    qrcode?: QrCodeFactory;
  }
}

/** 本机是否已经加载了二维码库 */
export function isQrAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.qrcode === 'function';
}

/**
 * 把一段文本渲染成二维码 SVG 字符串。
 *
 * 出错时抛异常而不是返回空串：调用方据此显示「二维码没出来，请叫服务员」，
 * 总比给顾客看一块空白、让他一直等要好。
 */
export function renderQrSvg(payload: string, cellSize = 8, margin = 16): string {
  if (!payload || payload.trim() === '') {
    throw new Error('二维码内容为空');
  }
  if (!isQrAvailable()) {
    throw new Error('二维码组件没有加载成功');
  }
  // typeNumber = 0 表示自动选择版本，纠错级别 M 是扫码场景的常规选择
  const qr = window.qrcode!(0, 'M');
  qr.addData(payload);
  qr.make();
  // 生成出来的 <svg> 不带 viewBox 之类的自适应属性，由外层 CSS 控制尺寸
  return qr.createSvgTag({ cellSize, margin, title: '扫码付款' });
}
